import React from 'react';
import PropTypes from 'prop-types';
import Image from 'components/Image';
const Banner = ({
  backgroundSrc,
  title,
  children,
  style,
  customCSS = '',
  fullWidth,
  className,
  altTitle = null,
}) => (
  <Image
    type="background"
    tag="section"
    src={backgroundSrc}
    className={`inner-hero-area${className ? ` ${className}` : ''}`}
    css={`
      margin-top: -94px;

      @media only screen and (max-width: 990px) {
        margin-top: -164px;
      } 
      ${customCSS}
    `}
    style={{ padding: '240px 0 80px', ...style }}
  >
    <div className="container">
      {fullWidth ? (
        <>
          <h1 className="white-txt" style={{ marginBottom: 10 }}>
            {title}
          </h1>
          <div className="inner-hero-content">{children}</div>
        </>
      ) : (
        <div className="row" >
          <div className="col-md-6" >
            <h1 className="white-txt" style={{ marginBottom: 10 }}>
              {title}
            </h1>
            <div className="inner-hero-content">{children}</div>
          </div>
          {altTitle}
        </div>
      )}
    </div>
  </Image>
);

Banner.propTypes = {
  backgroundSrc: PropTypes.string,
  title: PropTypes.oneOfType(PropTypes.string, PropTypes.node),
  style: PropTypes.object,
  children: PropTypes.node,
  customCSS: PropTypes.string,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
};

export default Banner;
